import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

const SpeedCenter = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
	return (
		<SvgIcon ref={ref} viewBox="0 0 24 24" {...props}>
			<g>
				<path
					d="M9.809,6.529C6.701,7.63 4.449,10.61 4.449,14.076C4.449,15.478 4.817,16.856 5.518,18.071L19.378,18.071C20.719,15.744 20.801,12.892 19.598,10.491L20.828,8.641L20.838,8.631C22.879,11.779 22.983,15.822 21.108,19.071C20.749,19.692 20.084,20.074 19.368,20.071L5.518,20.071C4.808,20.067 4.152,19.686 3.798,19.071C2.934,17.56 2.48,15.85 2.48,14.109C2.48,9.827 5.231,6.136 9.048,4.723L9.809,6.529Z"
					fill="currentColor"
				/>
				<path
					d="M15.991,4.766C19.748,6.21 22.445,9.869 22.445,14.109C22.445,15.85 21.991,17.56 21.127,19.071C20.772,19.686 20.116,20.067 19.407,20.071L5.557,20.071C4.841,20.074 4.175,19.692 3.817,19.071C1.941,15.822 2.046,11.779 4.087,8.631L4.097,8.641L5.327,10.491C4.123,12.892 4.206,15.744 5.547,18.071L19.407,18.071C20.107,16.856 20.476,15.478 20.476,14.076C20.476,10.702 18.342,7.788 15.361,6.62L15.991,4.766Z"
					fill="currentColor"
				/>
				<g transform="matrix(0.707581,-0.706632,0.706632,0.707581,-6.30152,12.9101)">
					<path
						d="M11.038,15.481C10.662,15.106 10.451,14.597 10.451,14.066C10.451,13.536 10.662,13.026 11.038,12.651L19.528,6.991L13.868,15.481C13.493,15.857 12.983,16.068 12.453,16.068C11.922,16.068 11.413,15.857 11.038,15.481ZM15.352,11.426C14.238,11.298 12.515,12.81 13.156,13.891C13.606,14.651 17.09,12.461 15.159,11.441C17.09,12.461 13.606,14.651 13.156,13.891C12.515,12.81 14.238,11.298 15.352,11.426Z"
						fill="currentColor"
					/>
				</g>
			</g>
		</SvgIcon>
	);
});

SpeedCenter.displayName = "SpeedCenter";

export default SpeedCenter;
